(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.win-groups.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.win-groups.js');
"use strict";

const {
  ReactPaper: Paper
} = svs.ui;
const {
  SkeletonLine
} = svs.components.lbUi;
const WinGroupsRowSkeleton = () => React.createElement("div", {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content"
}, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content__text1"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content__text2"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content__text3"
}));
const WagerSkeletonWinGroups = _ref => {
  let {
    numberOfWinGroups = 5
  } = _ref;
  return React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__win_groups"
  }, Array.from({
    length: numberOfWinGroups
  }).map((_, i) => {
    const key = "win-groups-".concat(i);
    return React.createElement(WinGroupsRowSkeleton, {
      key: key
    });
  }));
};
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonWinGroups', WagerSkeletonWinGroups);

 })(window);